import { NestedHome } from '@habity/types';
import { HomeDataBuilder } from './data-builder';
import { buildingFields } from './building-fields';

export const getBuildingData = (home: NestedHome) => {
  if (!home.provider_data || !home.provider_type) return [];

  return new HomeDataBuilder(home)
    .addFields(buildingFields)
    .build();
};

export const getBuildingDescription = (home: NestedHome) => {
  const { property_designation } = home?.address || {};
  return property_designation
    ? `Fastigheten ${property_designation}`
    : 'Fastighetsdata';
};
